import { Postrequestcall } from "../../request/Postrequest";
import { BIBlue } from "../../assets/helpers";
import BuilderIcon from "../../assets/images/profile_logo.jpg";
import { FETCH_CLIENTS_EMPLOYEES, CLIENT_DETAILS_BY_USERID_NEW } from "../../constant/Apipath";

function capitalizeFirstLetterFields(obj) {
  if (Array.isArray(obj)) {
    return obj.map(capitalizeFirstLetterFields);
  } else if (obj && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.charAt(0).toUpperCase() + key.slice(1),
        capitalizeFirstLetterFields(value)
      ])
    );
  }
  return obj;
}

export const getClientList = (responseClientList) => {
  const modifiedClientList = responseClientList.map((item) => ({
    ...item,
    clientEmployeeId: item.ClientEmployeeId || item.id || item.Id
  }));

  let getClientlist = modifiedClientList?.filter((item) => {
    const status = item?.invitationStatus || item?.InvitationStatus;
    const clientId = item?.clientId || item?.ClientId;
    return status === "Accepted" && clientId !== 0 && item?.ClientEmployeeId !== 0;
  });
  let capitalizedClientList = capitalizeFirstLetterFields(getClientlist);
  return capitalizedClientList;
};

// Revised to return data logic for handling in Login component
export const getUserinformation = async (loginRes, deviceId) => {
  if (loginRes) {
    let responseClientList = [];
    let pendingInvitations = [];
    try {
      const detailPayload = {
        UserId: Number(loginRes?.userInformation?.UserId),
        UserEmail: loginRes?.userInformation?.Email
      };
      const detailRes = await Postrequestcall(
        CLIENT_DETAILS_BY_USERID_NEW,
        detailPayload,
        loginRes?.accessToken
      );
      // Based on user image, Data contains ClientsList
      responseClientList = detailRes?.data?.Data?.ClientsList || [];
      pendingInvitations =
        detailRes?.data?.Data?.ClientInvitation || detailRes?.data?.Data?.ClientInvitations || [];
    } catch (error) {
      console.log("CLIENT_DETAILS_BY_USERID_NEW Error:", error);
    }

    const capitalizedClientList = getClientList(responseClientList);
    let getObj = {
      ...loginRes,
      userInformation: {
        ...loginRes.userInformation,
        TradeName: loginRes?.userInformation?.TradeName || "",
        ClientsList: capitalizedClientList,
        PendingInvitations: pendingInvitations,
        DeviceID: deviceId
      }
    };

    // Return the object so Login.jsx can handle the modal flow
    return getObj;
  }
  return null;
};
